import Adal from '../adal/adal-request';
import { encodeData, INITIATIVE_TYPE, REST_URL } from '../constants';
import * as types from './actionTypes';

const q = require('q');

export function fetchInitiatives(pageIndex = 1, pageSize = 50, filter = {}) {
  filter = { pageIndex, pageSize, ...filter };
  return ({
    type: types.FETCH_INITIATIVES,
    payload: Adal.adalRequest({ url: `${REST_URL}Initiatives?${encodeData(filter)}` })
  });
}

export function fetchInitiativeAction(id) {
  return ({
    type: types.FETCH_INITIATIVE,
    payload: Adal.adalRequest({ url: `${REST_URL}Initiatives/${id}` })
  });
}


export function fetchInitiativeTypesAction(IncludeInactive) {
  return ({
    type: types.FETCH_INITIATIVE_TYPES,
    payload: Adal.adalRequest({ url: `${REST_URL}Initiatives/types?IncludeInactive=${IncludeInactive || false}` })
  });
}


export function fetchCostCentersAction() {
  return ({
    type: types.FETCH_COST_CENTERS,
    payload: Adal.adalRequest({ url: `${REST_URL}CostCenters` })
  });
}

export function saveRewardAction(initiativeId, reward) {
  return ({
    type: types.SAVE_REWARD,
    payload: Adal.adalRequest({ url: `${REST_URL}Initiatives/reward/${initiativeId}`, method: 'PUT', data: JSON.stringify(reward) })
  });
}


export function fetchInitiativeJournalsAction(initiativeId) {
  return ({
    type: types.FETCH_INITIATIVE_JOURNALS,
    payload: Adal.adalRequest({ url: `${REST_URL}Initiatives/journals/${initiativeId}` })
  });
}

export function saveInitiativeTypeAction(initiativeType) {
  if (initiativeType.Id) {
    return ({
      type: types.SAVE_INITIATIVE_TYPE,
      payload: Adal.adalRequest({ url: `${REST_URL}Initiatives/types/${initiativeType.Id}`, method: 'PUT', data: JSON.stringify(initiativeType) })
    });
  }
  return ({
    type: types.SAVE_INITIATIVE_TYPE,
    payload: Adal.adalRequest({ url: `${REST_URL}Initiatives/types`, method: 'POST', data: JSON.stringify(initiativeType) })
  });
}

export function saveInitiativeCommentAction(initiativeId, comment) {
  return ({
    type: types.SAVE_INITIATIVE_COMMENT,
    payload: Adal.adalRequest({ url: `${REST_URL}Initiatives/comment/${initiativeId}`, method: 'POST', data: JSON.stringify({ Comment: comment, InitiativeId: initiativeId }) })
  });
}

export function saveInitiativeDecisionAction(initiativeId, decision) {
  return ({
    type: types.SAVE_INITIATIVE_DECISION,
    payload: Adal.adalRequest({ url: `${REST_URL}Initiatives/decision/${initiativeId}`, method: 'POST', data: JSON.stringify(decision) })
  });
}

export function sendInitiativeOpinionRequestsAction(initiativeId, requests) {
  return ({
    type: types.SEND_INITIATIVE_OPINION_REQUEST,
    payload: Adal.adalRequest({ url: `${REST_URL}Initiatives/opinionRequest/${initiativeId}`, method: 'POST', data: JSON.stringify(requests) })
  });
}


export function setInitiativeFilter(filter) {
  return ({
    type: types.SET_INITIATIVE_FILTER,
    payload: filter
  });
}

export function reAssignInitiativeAction(initiativeId, targetUserId) {
  return ({
    type: types.RE_ASSIGN_INITIATIVE,
    payload: Adal.adalRequest({ url: `${REST_URL}Initiatives/reassign/${initiativeId}/${targetUserId}`, method: 'PUT' })
  });
}

export function addInitiativeAction(initiative, Files) {
  const deferred = q.defer();
  Adal.adalRequest({ url: `${REST_URL}Initiatives`, method: 'POST', data: JSON.stringify(initiative) }).then((payload) => {
    const fd = new FormData();
    if (Files.length > 0) {
      for (let it = 0; it < Files.length; it++) {
        const f = Files[it];
        fd.append(f.name, f);
      }
      Adal.adalRequest({ url: `${REST_URL}fileItems/upload/${INITIATIVE_TYPE}/${payload.Id}`, method: 'POST', ignoreResponseType: true, ignoreContentType: true, data: fd }).then(() => {
        deferred.resolve(payload);
      }, deferred.reject);
    } else {
      deferred.resolve(payload);
    }

  }, deferred.reject);
  return ({
    type: types.ADD_INITIATIVE,
    payload: deferred.promise
  });
}


export function putInitiativeAction(initiative, newFiles) {
  const deferred = q.defer();
  Adal.adalRequest({ url: `${REST_URL}Initiatives/${initiative.Id}`, method: 'PUT', data: JSON.stringify(initiative) }).then((payload) => {
    const fd = new FormData();
    if (newFiles && newFiles.length > 0) {
      for (let it = 0; it < newFiles.length; it++) {
        const f = newFiles[it];
        fd.append(f.name, f);
      }
      Adal.adalRequest({ url: `${REST_URL}fileItems/upload/${INITIATIVE_TYPE}/${initiative.Id}`, method: 'POST', ignoreResponseType: true, ignoreContentType: true, data: fd }).then(() => {
        deferred.resolve(payload);
      }, deferred.reject);
    } else {
      deferred.resolve(payload);
    }
  }, deferred.reject);
  return ({
    type: types.UPDATE_INITIATIVE,
    payload: deferred.promise
  });
}



// WEBPACK FOOTER //
// ./actions/initiativeActions.js